import { useEffect } from "react"
import { RotateCcw } from "lucide-react"
import { LogoMark } from "../components/Chrome"
import { HiddenField, MethodField } from "../lib/rails"

export function RepositoryResetPage({
  csrfToken = "",
  publicRepository = false,
  redirectPath = "/",
  repositoryName = "this repository",
  resetComplete = true,
  resetPath = ""
}) {
  useEffect(() => {
    if (!resetComplete) return undefined
    if (typeof window === "undefined") return undefined

    const timeoutId = window.setTimeout(() => {
      window.location.assign(redirectPath || "/")
    }, 1000)

    return () => window.clearTimeout(timeoutId)
  }, [redirectPath, resetComplete])

  if (!resetComplete) {
    return (
      <section className="welcome-page repository-reset-page">
        <div className="welcome-content">
          <LogoMark className="welcome-logo" />
          <span className="welcome-wordmark">Conceptive</span>
          <h1 className="welcome-headline">Reset repository?</h1>
          <p className="repository-reset-copy">
            {publicRepository
              ? `Resetting ${repositoryName} will remove its shared clone and generated analysis for everyone using this public repository.`
              : `Resetting ${repositoryName} will remove its local clone and generated analysis for this workspace.`}
          </p>
          <form className="repository-reset-form" method="post" action={resetPath}>
            <MethodField method="delete" />
            <HiddenField name="authenticity_token" value={csrfToken} />
            <button type="submit" className="repository-reset-button">
              <RotateCcw aria-hidden="true" strokeWidth={1.8} />
              Reset repository
            </button>
          </form>
          <a href={redirectPath || "/"} className="welcome-secondary-link repository-reset-cancel">
            Cancel
          </a>
        </div>
      </section>
    )
  }

  return (
    <section className="welcome-page repository-reset-page">
      <div className="welcome-content">
        <LogoMark className="welcome-logo" />
        <span className="welcome-wordmark">Conceptive</span>
        <h1 className="welcome-headline">Repository reset</h1>
        <p className="repository-reset-copy">
          Returning to all repositories<span className="continue-loading-dots" aria-hidden="true"><span>.</span><span>.</span><span>.</span></span>
        </p>
      </div>
    </section>
  )
}
